import React, { useEffect, useState } from 'react';
export function StickyCart() {
  const [isVisible, setIsVisible] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      // Show sticky cart after scrolling down 300px
      if (window.scrollY > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  if (!isVisible) return null;
  return <div className="fixed bottom-0 left-0 right-0 z-50 animate-slide-up px-4 py-4" data-id="element-440">
      <div className="max-w-4xl mx-auto" data-id="element-441">
        <a href="https://cotevich.com/products/pestrepeller" target="_blank" rel="noopener noreferrer" className="block w-full bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-6 rounded-lg text-center transition-colors shadow-lg text-xl" data-id="element-442">
          GET 40% OFF Cotevich Now!
        </a>
      </div>
    </div>;
}